import React from 'react'

const SvgUserCardOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 4H4v16h16V4zM4 2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2H4z'
    />
    <path d='M6 16a3 3 0 013-3h6a3 3 0 013 3v.15A1.85 1.85 0 0116.15 18h-8.3A1.85 1.85 0 016 16.15V16zM15 8a3 3 0 11-6 0 3 3 0 016 0z' />
  </svg>
)

export default SvgUserCardOutline
